import React, { useState } from 'react';
import RoutePath from 'App/RoutePath';
import getSubdomainFromUrl from 'utils/getSubdomainFromUrl';
import { useHistory } from 'react-router-dom';
import { TypedRegistrationFlow } from './Forms/RegistrationFlow/TypedRegistrationFlow';
import { RegistrationFlow } from './Forms/RegistrationFlow/constants';
import { RegistrationFlowState } from './Forms/RegistrationFlow/types';
import { useCreateInvitedUser } from './hooks/useCreateInvitedUser';
import { useValidateInvitationToken } from './hooks/useValidateInvitationToken';

export const InvitedUserSignUp = () => {
  const subdomain = getSubdomainFromUrl();
  const history = useHistory();
  const [redirectState, setRedirectState] = useState({
    email: '',
    redirectTo: RoutePath.SignUp,
  });
  const { validToken } = useValidateInvitationToken();

  const { createInvitedUser, error: invitedUserError } = useCreateInvitedUser({
    onSuccess: () => {
      history.push({
        pathname: RoutePath.EmailConfirmation,
        search: `?invite_token=${validToken}`,
        state: redirectState,
      });
    },
  });

  return (
    <TypedRegistrationFlow
      error={invitedUserError}
      registrationFlow={RegistrationFlow.INVITED_USER_SIGNUP}
      onEnd={async (
        args: RegistrationFlowState[RegistrationFlow.INVITED_USER_SIGNUP],
      ) => {
        if (validToken) {
          setRedirectState(prevState => ({
            ...prevState,
            email: args.email,
          }));

          await createInvitedUser({
            firstName: args.firstName,
            lastName: args.lastName,
            password: args.password,
            email: args.email,
            subdomain,
            timezone: 'Europe',
            invitationToken: validToken,
            explicitPrivacyConsentGiven:
              args.explicitPrivacyConsentGiven || false,
            explicitEEADataStorageConsentGiven:
              args.explicitEEADataStorageConsentGiven || false,
            explicitHealthDataConsentGiven: true, // user can only submit if they've given health data consent
            marketingOptIn: args.marketingOptIn || false,
            piplPrivacyPolicyConsentGiven: args.piplPrivacyPolicyConsentGiven,
            piplSensitiveDataConsentGiven: args.piplSensitiveDataConsentGiven,
            piplThirdPartySharingConsentGiven:
              args.piplThirdPartySharingConsentGiven,
            piplCrossBorderTransferConsentGiven:
              args.piplCrossBorderTransferConsentGiven,
          });
        }
      }}
      parentPath={RoutePath.SignUp}
    />
  );
};
